module.exports = __webpack_public_path__ + "static/media/PATS_1-420w.48111bc5.webp";